import {CloseOutlined, InfoCircleOutlined} from '@ant-design/icons';
import {CountdownTimer} from '@countdown-timer';
import {BottomSheet, Button, IconButton, OtpInput} from '@ds/components';
import {numberFormat} from 'utils/Helper';

type OtpPaymentSheetProps = {
  show: boolean;
  onClose: () => void;
  otp: string;
  setOtp: React.Dispatch<React.SetStateAction<string>>;
  countDown: number;
  setCountDown: React.Dispatch<React.SetStateAction<number>>;
  vendorNumber: string;
  totalPrice: number;
  confirmPaymentLoading: boolean;
  resendOtp: () => void;
  finalizePayment: () => void;
};

const OtpPaymentSheet: React.FC<OtpPaymentSheetProps> = ({
  show,
  onClose,
  otp,
  setOtp,
  countDown,
  setCountDown,
  vendorNumber,
  totalPrice,
  confirmPaymentLoading,
  resendOtp,
  finalizePayment
}) => {
  return (
    <BottomSheet
      show={show}
      onClose={onClose}
      header={
        <div className="flex items-center gap-2 px-2 pt-2">
          <IconButton aria-label="بستن" size="md" onClick={onClose}>
            <CloseOutlined aria-hidden />
          </IconButton>
          <h2 className="text-subtitle-md text-neutral-fg">دریافت رمز یکبار مصرف</h2>
        </div>
      }
      footer={
        <div className="flex items-center justify-between gap-3 border-t border-gray-03 p-3">
          <div className="flex min-w-0 flex-col text-body-sm">
            <span className="text-gray-07">مبلغ قابل پرداخت</span>
            <span className="text-body-sm-emphasis text-neutral-fg">
              {numberFormat(totalPrice)} تومان
            </span>
          </div>
          <Button onClick={finalizePayment} loading={confirmPaymentLoading}>
            تایید پرداخت
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4 p-4">
        <p className="text-body-sm text-neutral-fg">
          برای تایید پرداخت، رمز یک‌بارمصرف ارسال شده به شمارهٔ {vendorNumber} را در زیر وارد کنید.
        </p>
        <OtpInput length={5} value={otp} onChange={setOtp} />
        <div className="flex items-center justify-center gap-2.5 text-body-sm text-gray-08">
          {countDown > 0 ? (
            <>
              <span>درخواست دوباره رمز تا</span>
              <CountdownTimer initialCounter={countDown} setCountDown={setCountDown} />
            </>
          ) : (
            <>
              <span>کد را دریافت نکردید؟</span>
              <Button
                className="px-0!"
                onClick={resendOtp}
                variant="link"
                color="primary"
                size="sm"
              >
                ارسال دوباره کد
              </Button>
            </>
          )}
        </div>
        <div className="flex gap-2.5 rounded-xl bg-brand-surface p-4 text-body-sm text-neutral-fg">
          <InfoCircleOutlined aria-hidden className="mt-1 shrink-0 text-body-lg" />
          <p>مبلغ قابل پرداخت در زمان تسویه در اولین موعد از فاکتور شما کسر می‌گردد.</p>
        </div>
      </div>
    </BottomSheet>
  );
};

export default OtpPaymentSheet;
